import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CoveragePeriods,
  FlexListHeader,
  Inscription,
  ListItemBase,
} from '@common-fe/common-fe';
import { uniqueId } from 'lodash';
import styled from 'styled-components';

import currentTheme from '@/styles/theme';

import { EnrollmentCoverageInfoHint } from './EnrollmentCoverageInfoHint';

const Wrapper = styled(Box)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings.spacing8};
  }
`;

const CoveragePeriodsTable: React.FC<{
  coveragePeriods: CoveragePeriods[],
  externalDeductibleMet?: string;
}> = ({ coveragePeriods, externalDeductibleMet }) => {
  const { t } = useTranslation();
  const headers: ListItemBase[] = useMemo(() => {
    const currentHeaders = [{
      key: 'period',
      title: t('Period'),
    }];
    return currentHeaders;
  }, [t]);

  return (
    <Box
      data-testId="coverage-periods-wrapper"
      background="module"
      pad="xs"
      round="small"
      margin={{ vertical: 'xs' }}
    >
      <FlexListHeader items={headers} thinMode />
      {coveragePeriods.map((item, index) => (
        <Wrapper
          key={uniqueId()}
          height="42px"
          background="canvas"
          elevation="default"
          round={currentTheme.rounds.button1Round}
          margin={{ top: index === 0 ? 'xs' : '0px' }}
          pad={{ vertical: 's', horizontal: 'l' }}
          direction="row"
          align="center"
        >
          <Box height="24px" direction="row" align="center">
            <Inscription size="12px" lineHeight="18px" style={{ fontWeight: 500 }}>{item.startDate}</Inscription>
            &nbsp;-&nbsp;
            <Inscription size="12px" lineHeight="18px" style={{ fontWeight: 500 }}>{item.endDate}</Inscription>
          </Box>

          {(item?.limitedPeriods && item?.limitedPeriods.length) || externalDeductibleMet ? (
            <Box
              width={{ max: '16px', min: '16px' }}
              margin={{ left: 'spacing24' }}
            >
              <EnrollmentCoverageInfoHint
                limitedPeriods={item?.limitedPeriods}
                externalDeductibleMet={externalDeductibleMet}
                coveragePeriods={coveragePeriods}
              />
            </Box>
          )
            : null}
        </Wrapper>
      ))}
    </Box>
  );
};

export default CoveragePeriodsTable;
